export const CONTAC_DASHBOARD = () => `/contac-dashboard`;
